import React, { useState, useCallback, useEffect } from "react";
import plusFill from "@iconify/icons-eva/plus-fill";
import eyeFill from "@iconify/icons-eva/eye-fill";
import eyeOffFill from "@iconify/icons-eva/eye-off-fill";
import { Icon } from "@iconify/react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Button,
  IconButton,
  Box,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  InputAdornment,
  Tooltip,
  Chip,
  Avatar,
  Switch,
  FormControlLabel,
  CircularProgress,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
  Menu,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core";
import Scrollbar from "../Scrollbar";
import AgregarClavesPortales from "./AgregarClavesPortales";
import { makeStyles } from "@material-ui/styles";
import MyConfirmationDialog from "../MyConfirmationDialog";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import SearchIcon from "@material-ui/icons/Search";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import BusinessIcon from "@material-ui/icons/Business";
import MoreVertIcon from "@material-ui/icons/MoreVert";

import EditarClavesPortales from "./EditarClavesPortales";
import { clientesApi } from "src/services/clientesApi";
import { useSelector } from "react-redux";
import { useSnackbar } from "src/components/snackbar";
import ContentCopyIcon from "@material-ui/icons/FileCopy";
import ModalHistorialAuditoriaClaves from "./ModalHistorialAuditoriaClaves";
import { History as HistoryIcon } from "@material-ui/icons";
import ModalAdvertenciaCopiaClave from "./ModalAdvertenciaCopiaClave";

const styles = makeStyles((theme) => ({
  root: {
    minWidth: 275,
  },
  title: {
    textAlign: "center",
    fontSize: "24px",
    marginBottom: "1rem",
  },
  textfield: {
    width: "100%",
  },
  grid: {
    xs: 12,
    alignItems: "center",
    justify: "center",
    marginBottom: "1rem",
  },
  pos: {
    marginBottom: 12,
  },
  formControl: {
    minWidth: "100%",
    marginBottom: 12,
    marginTop: 12,
  },
  accordionHeader: {
    backgroundColor: theme.palette.grey[50],
    borderBottom: `1px solid ${theme.palette.divider}`,
    "&:hover": {
      backgroundColor: theme.palette.grey[100],
    },
  },
  accordionContent: {
    padding: theme.spacing(2),
    backgroundColor: "#fafafa",
  },
  claveCard: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    backgroundColor: "white",
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
    transition: "box-shadow 0.3s",
    "&:hover": {
      boxShadow: theme.shadows[2],
    },
  },
  institucionAvatar: {
    backgroundColor: theme.palette.primary.main,
    marginRight: theme.spacing(2),
  },
  menuButton: {
    padding: theme.spacing(0.5),
    color: theme.palette.text.secondary,
    "&:hover": {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.action.hover,
    },
  },
}));

export default function EditarClavesCliente(props) {
  const { value, cliente } = props;
  // const [clavesPortales, setClavesPortales] = useState([]);
  const [deleteMessage, setDeleteMessage] = useState(false);
  const [open, setOpen] = useState(false);
  const [openEditar, setOpenEditar] = useState(false);
  const [elementoSeleccionado, setElementoSeleccionado] = useState(null);
  const classes = styles();
  const [passwordsVisibles, setPasswordsVisibles] = useState({});
  const [passwordsDesencriptadas, setPasswordsDesencriptadas] = useState({});

  const [modalHistorialOpen, setModalHistorialOpen] = useState(false);
  const [claveSeleccionadaHistorial, setClaveSeleccionadaHistorial] =
    useState(null);
  const [dialogAdvertenciaOpen, setDialogAdvertenciaOpen] = useState(false);
  const [claveParaCopiar, setClaveParaCopiar] = useState(null);
  const [mostrarAdvertenciaCopia, setMostrarAdvertenciaCopia] = useState(true);

  // Estados para búsqueda y filtros
  const [busqueda, setBusqueda] = useState("");
  const [filtroFormato, setFiltroFormato] = useState("TODOS");
  // Estado para controlar qué accordions están expandidos
  const [expandedAccordions, setExpandedAccordions] = useState({});
  // Estado para el menú contextual
  const [anchorEl, setAnchorEl] = useState(null);
  const [claveSeleccionadaMenu, setClaveSeleccionadaMenu] = useState(null);

  // Obtener rol del usuario logueado
  const {
    rol: rolObtenido,
    sucursal: { refSucursal },
  } = useSelector((state) => state.auth.user);

  const rolUsuario = rolObtenido || "EMPLEADO";
  const puedeVerPassword = ["SUPER_ADMIN"].includes(rolUsuario);

  // Verificar si ya vio la advertencia de seguridad en esta sesión
  useEffect(() => {
    const yaVioAdvertencia = sessionStorage.getItem(
      "vio-advertencia-copia-claves",
    );
    if (yaVioAdvertencia) {
      setMostrarAdvertenciaCopia(false);
    }
  }, []);

  const { data: clavesPortales = [] } =
    clientesApi.useObtenerClavesClienteQuery({ rut: cliente.rut });
  const [desencriptarClave, { isLoading: isDesencriptando }] =
    clientesApi.useDesencriptarClaveMutation();

  // Filtrar claves según búsqueda y formato
  const clavesFiltradas = useCallback(() => {
    let resultado = [...clavesPortales];

    // Filtro por búsqueda (institución o usuario)
    if (busqueda.trim() !== "") {
      const busquedaLower = busqueda.toLowerCase();
      resultado = resultado.filter(
        (clave) =>
          clave.institucion?.toLowerCase().includes(busquedaLower) ||
          clave.usuario?.toLowerCase().includes(busquedaLower),
      );
    }

    // Filtro por formato
    if (filtroFormato !== "TODOS") {
      if (filtroFormato === "NECESITA_MIGRACION") {
        resultado = resultado.filter(
          (clave) => clave.necesitaMigracion === true,
        );
      } else {
        resultado = resultado.filter(
          (clave) =>
            clave.formatoEncriptacion?.toLowerCase() ===
            filtroFormato.toLowerCase(),
        );
      }
    }

    return resultado;
  }, [clavesPortales, busqueda, filtroFormato]);

  const clavesParaMostrar = clavesFiltradas();

  // Agrupar claves por institución
  const agruparPorInstitucion = useCallback(() => {
    const grupos = {};

    clavesParaMostrar.forEach((clave) => {
      const institucion = clave.institucion || "Sin Institución";

      if (!grupos[institucion]) {
        grupos[institucion] = [];
      }

      grupos[institucion].push(clave);
    });

    // Ordenar instituciones alfabéticamente
    const institucionesOrdenadas = Object.keys(grupos).sort((a, b) =>
      a.localeCompare(b),
    );

    return institucionesOrdenadas.map((institucion) => ({
      institucion,
      claves: grupos[institucion],
      cantidad: grupos[institucion].length,
    }));
  }, [clavesParaMostrar]);

  const clavesAgrupadas = agruparPorInstitucion();

  // Manejar expansión/colapso de accordions
  const handleAccordionChange = useCallback(
    (institucion) => (event, isExpanded) => {
      setExpandedAccordions((prev) => ({
        ...prev,
        [institucion]: isExpanded,
      }));
    },
    [],
  );

  // Expandir/colapsar todos
  const expandirTodos = useCallback(() => {
    const todosExpandidos = {};
    clavesAgrupadas.forEach((grupo) => {
      todosExpandidos[grupo.institucion] = true;
    });
    setExpandedAccordions(todosExpandidos);
  }, [clavesAgrupadas]);

  const colapsarTodos = useCallback(() => {
    setExpandedAccordions({});
  }, []);

  // Abrir menú contextual
  const handleOpenMenu = useCallback((event, clave) => {
    event.stopPropagation(); // Evita que se expanda/colapse el accordion
    setAnchorEl(event.currentTarget);
    setClaveSeleccionadaMenu(clave);
  }, []);

  // Cerrar menú contextual
  const handleCloseMenu = useCallback(() => {
    setAnchorEl(null);
    setClaveSeleccionadaMenu(null);
  }, []);

  // Manejar acción de editar desde el menú
  const handleEditarDesdeMenu = useCallback(() => {
    if (claveSeleccionadaMenu) {
      setElementoSeleccionado(claveSeleccionadaMenu);
      setOpenEditar(true);
      handleCloseMenu();
    }
  }, [claveSeleccionadaMenu, handleCloseMenu]);

  // Manejar acción de eliminar desde el menú
  const handleEliminarDesdeMenu = useCallback(() => {
    if (claveSeleccionadaMenu) {
      setElementoSeleccionado(claveSeleccionadaMenu);
      setDeleteMessage(true);
      handleCloseMenu();
    }
  }, [claveSeleccionadaMenu, handleCloseMenu]);

  // Generar clave única para identificar cada fila
  const generarClaveUnica = (refCliente, institucion, usuario) => {
    return `${refCliente}-${institucion}-${usuario}`;
  };

  const [eliminarClaveCliente] = clientesApi.useEliminarClaveClienteMutation();
  const [cambiarVisibilidadClave] =
    clientesApi.useCambiarVisibilidadClaveMutation();
  const [updatingVisibilidadId, setUpdatingVisibilidadId] = useState(null);
  const { enqueueSnackbar } = useSnackbar();

  const eliminar = useCallback(
    async (clavesCliente) => {
      try {
        await eliminarClaveCliente({
          id: clavesCliente.id,
          refSucursal,
        }).unwrap();

        setDeleteMessage(false);
        enqueueSnackbar("Clave eliminada correctamente", {
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "right",
          },
        });
      } catch (error) {
        console.error("Error al eliminar clave cliente:", error);
        enqueueSnackbar(
          error?.data?.message ||
            error.message ||
            "Ocurrió un error desconocido al eliminar la clave",
          {
            variant: "error",
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "right",
            },
          },
        );
      }
    },
    [eliminarClaveCliente, enqueueSnackbar, refSucursal],
  );
  const handleToggleVisibilidad = useCallback(
    async (clave) => {
      setUpdatingVisibilidadId(clave.id);
      try {
        await cambiarVisibilidadClave({
          id: clave.id,
          visibleCliente: !clave.visibleCliente,
          refSucursal,
        }).unwrap();
        enqueueSnackbar(
          clave.visibleCliente
            ? "Clave oculta para el cliente"
            : "Clave visible para el cliente",
          {
            variant: "success",
            anchorOrigin: { vertical: "bottom", horizontal: "right" },
          },
        );
      } catch (error) {
        enqueueSnackbar(
          error?.data?.message || "No se pudo cambiar la visibilidad",
          {
            variant: "error",
            anchorOrigin: { vertical: "bottom", horizontal: "right" },
          },
        );
      } finally {
        setUpdatingVisibilidadId(null);
      }
    },
    [cambiarVisibilidadClave, enqueueSnackbar, refSucursal],
  );

  // Manejar visualización de contraseña
  const handleTogglePassword = useCallback(
    async (refCliente, institucion, usuario, claveEncriptada) => {
      const claveUnica = generarClaveUnica(refCliente, institucion, usuario);

      // Si ya está visible, solo ocultarla
      if (passwordsVisibles[claveUnica]) {
        setPasswordsVisibles((prev) => ({
          ...prev,
          [claveUnica]: false,
        }));
        return;
      }

      // Si no está visible y no tenemos permisos, mostrar mensaje
      if (!puedeVerPassword) {
        enqueueSnackbar(
          "No tienes permisos para visualizar contraseñas. Solo usuarios SUPER_ADMIN pueden hacerlo.",
          {
            variant: "warning",
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "right",
            },
          },
        );
        return;
      }

      // Si no está visible y tenemos permisos, desencriptar desde el backend
      try {
        const resultado = await desencriptarClave({
          refCliente,
          institucion,
          usuario,
          refSucursal,
          accion: "VISUALIZACION",
        }).unwrap();

        // Guardar la contraseña desencriptada
        setPasswordsDesencriptadas((prev) => ({
          ...prev,
          [claveUnica]: resultado.claveDesencriptada,
        }));

        // Marcar como visible
        setPasswordsVisibles((prev) => ({
          ...prev,
          [claveUnica]: true,
        }));

        // Mostrar advertencia si necesita migración
        if (resultado.necesitaMigracion) {
          enqueueSnackbar(
            "Esta clave está en formato antiguo. Se recomienda actualizarla.",
            {
              variant: "info",
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "right",
              },
            },
          );
        }
      } catch (error) {
        console.error("Error al desencriptar:", error);

        let mensaje = "Error al obtener la contraseña";
        if (error.status === 403) {
          mensaje = "No tienes permisos para ver esta contraseña";
        } else if (error.status === 404) {
          mensaje = "Contraseña no encontrada";
        }

        enqueueSnackbar(mensaje, {
          variant: "error",
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "right",
          },
        });
      }
    },
    [
      passwordsVisibles,
      puedeVerPassword,
      enqueueSnackbar,
      desencriptarClave,
      refSucursal,
    ],
  );

  // Función auxiliar para copiar al portapapeles con limpieza automática
  const copiarAlPortapapeles = useCallback(
    async (password) => {
      try {
        await navigator.clipboard.writeText(password);

        enqueueSnackbar("Contraseña copiada (se limpiará en 45 segundos)", {
          variant: "success",
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "right",
          },
        });

        // Limpiar portapapeles después de 45 segundos
        setTimeout(async () => {
          try {
            // Verificar que aún está la misma contraseña
            const current = await navigator.clipboard.readText();
            if (current === password) {
              await navigator.clipboard.writeText("");
              console.log("Portapapeles limpiado por seguridad");
            }
          } catch (error) {
            // Ignorar errores (el navegador puede no permitir leer el portapapeles)
            console.log(
              "No se pudo verificar/limpiar portapapeles:",
              error.message,
            );
          }
        }, 45000); // 45 segundos
      } catch (error) {
        enqueueSnackbar("Error al copiar la contraseña", {
          variant: "error",
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "right",
          },
        });
      }
    },
    [enqueueSnackbar],
  );

  // Función interna que realiza la copia real (sin validación de advertencia)
  const ejecutarCopiaClave = useCallback(
    async (refCliente, institucion, usuario) => {
      const claveUnica = generarClaveUnica(refCliente, institucion, usuario);
      const passwordDesencriptada = passwordsDesencriptadas[claveUnica];

      if (passwordDesencriptada) {
        // Si ya tenemos la contraseña desencriptada en memoria, copiarla directamente
        await copiarAlPortapapeles(passwordDesencriptada);
      } else {
        // Si no está desencriptada, obtenerla del backend y copiar
        try {
          const resultado = await desencriptarClave({
            refCliente,
            institucion,
            usuario,
            refSucursal,
            accion: "COPIA", // Indicar que es una acción de copia
          }).unwrap();

          // Copiar al portapapeles con limpieza automática
          await copiarAlPortapapeles(resultado.claveDesencriptada);

          // Solo guardar en memoria si el usuario tiene permisos para VER
          // Esto evita que usuarios sin permisos puedan ver la contraseña después de copiarla
          if (puedeVerPassword) {
            setPasswordsDesencriptadas((prev) => ({
              ...prev,
              [claveUnica]: resultado.claveDesencriptada,
            }));
          }
        } catch (error) {
          console.error("Error al copiar:", error);

          let mensaje = "Error al copiar la contraseña";
          if (error.status === 403) {
            mensaje = "No tienes permisos para acceder a esta contraseña";
          } else if (error.status === 404) {
            mensaje = "Contraseña no encontrada";
          }

          enqueueSnackbar(mensaje, {
            variant: "error",
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "right",
            },
          });
        }
      }
    },
    [
      passwordsDesencriptadas,
      puedeVerPassword,
      desencriptarClave,
      enqueueSnackbar,
      refSucursal,
      copiarAlPortapapeles,
    ],
  );

  // Copiar contraseña al portapapeles
  // Esta función maneja la advertencia y luego llama a ejecutarCopiaClave
  const handleCopyPassword = useCallback(
    (refCliente, institucion, usuario) => {
      // Si es la primera vez en la sesión, mostrar advertencia
      if (mostrarAdvertenciaCopia) {
        setClaveParaCopiar({ refCliente, institucion, usuario });
        setDialogAdvertenciaOpen(true);
        return;
      }

      // Si ya vio la advertencia, ejecutar copia directamente
      ejecutarCopiaClave(refCliente, institucion, usuario);
    },
    [mostrarAdvertenciaCopia, ejecutarCopiaClave],
  );

  // Abrir modal de historial de auditoría
  const handleOpenHistorial = useCallback(
    (refCliente, institucion, usuario) => {
      setClaveSeleccionadaHistorial({ refCliente, institucion, usuario });
      setModalHistorialOpen(true);
    },
    [],
  );

  // Cerrar modal de historial
  const handleCloseHistorial = useCallback(() => {
    setModalHistorialOpen(false);
    setClaveSeleccionadaHistorial(null);
  }, []);

  // Renderizar badge de formato de encriptación
  const renderFormatoBadge = useCallback(
    (formatoEncriptacion, necesitaMigracion) => {
      const configs = {
        gcm: { label: "GCM", color: "primary" },
        cbc: { label: "CBC (Antiguo)", color: "default" },
        plano: { label: "Sin Encriptar", color: "secondary" },
      };

      const formato = formatoEncriptacion?.toLowerCase() || "plano";
      const config = configs[formato] || configs.plano;

      return (
        <Tooltip
          title={
            necesitaMigracion
              ? "Esta clave está en formato antiguo y debería actualizarse"
              : "Formato de encriptación actual"
          }
        >
          <Chip
            label={config.label}
            color={config.color}
            size="small"
            style={{ marginLeft: 8 }}
          />
        </Tooltip>
      );
    },
    [],
  );

  return (
    <div className={classes.pos}>
      {value === 1 && (
        <Card className={classes.root} variant="outlined">
          <CardContent>
            <Grid container spacing={2} className={classes.grid}>
              {/* Título */}
              <Grid item xs={12}>
                <Typography
                  variant="h5"
                  component="h2"
                  className={classes.title}
                >
                  Claves Portales
                </Typography>
              </Grid>

              {/* Buscador y filtros */}
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  variant="outlined"
                  size="small"
                  placeholder="Buscar por institución o usuario..."
                  value={busqueda}
                  onChange={(e) => setBusqueda(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon color="action" />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel id="filtro-formato-label">
                    Filtrar por formato
                  </InputLabel>
                  <Select
                    labelId="filtro-formato-label"
                    value={filtroFormato}
                    onChange={(e) => setFiltroFormato(e.target.value)}
                    label="Filtrar por formato"
                  >
                    <MenuItem value="TODOS">Todos los formatos</MenuItem>
                    <MenuItem value="GCM">🔒 Solo GCM (Seguras)</MenuItem>
                    <MenuItem value="CBC">⚠️ Solo CBC (Antiguas)</MenuItem>
                    <MenuItem value="PLANO">❌ Sin encriptar</MenuItem>
                    <MenuItem value="NECESITA_MIGRACION">
                      🔄 Necesitan migración
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={2} align="end">
                <Button
                  fullWidth
                  onClick={() => {
                    setOpen(true);
                  }}
                  variant="contained"
                  color="primary"
                  startIcon={<Icon icon={plusFill} />}
                >
                  Agregar
                </Button>
              </Grid>

              {/* Mensaje si no hay resultados */}
              {clavesParaMostrar.length === 0 && clavesPortales.length > 0 && (
                <Grid item xs={12}>
                  <Box textAlign="center" py={2}>
                    <Typography variant="body2" color="textSecondary">
                      No se encontraron claves con los filtros aplicados
                    </Typography>
                    <Button
                      size="small"
                      color="primary"
                      onClick={() => {
                        setBusqueda("");
                        setFiltroFormato("TODOS");
                      }}
                      style={{ marginTop: 8 }}
                    >
                      Limpiar filtros
                    </Button>
                  </Box>
                </Grid>
              )}
            </Grid>

            {/* Botones expandir/colapsar todos */}
            {clavesAgrupadas.length > 1 && (
              <Grid item xs={12}>
                <Box display="flex" gap={1} justifyContent="flex-end" mb={1}>
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={expandirTodos}
                  >
                    Expandir Todos
                  </Button>
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={colapsarTodos}
                  >
                    Colapsar Todos
                  </Button>
                </Box>
              </Grid>
            )}

            <Scrollbar>
              <Box sx={{ minWidth: 800 }}>
                {clavesAgrupadas.length === 0 ? (
                  <Box textAlign="center" py={4}>
                    <Typography variant="h6" color="textSecondary">
                      No hay claves que mostrar
                    </Typography>
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      style={{ marginTop: 8 }}
                    >
                      {clavesPortales.length === 0
                        ? "Agrega la primera clave del cliente"
                        : "Intenta ajustar los filtros de búsqueda"}
                    </Typography>
                  </Box>
                ) : (
                  clavesAgrupadas.map((grupo) => (
                    <Accordion
                      key={grupo.institucion}
                      expanded={expandedAccordions[grupo.institucion] || false}
                      onChange={handleAccordionChange(grupo.institucion)}
                      style={{ marginBottom: 8 }}
                    >
                      {/* Header del Accordion */}
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        className={classes.accordionHeader}
                      >
                        <Box display="flex" alignItems="center" width="100%">
                          <Avatar className={classes.institucionAvatar}>
                            <BusinessIcon />
                          </Avatar>
                          <Box flexGrow={1}>
                            <Typography
                              variant="h6"
                              style={{ fontWeight: 600 }}
                            >
                              {grupo.institucion}
                            </Typography>
                            <Typography variant="caption" color="textSecondary">
                              {grupo.cantidad}{" "}
                              {grupo.cantidad === 1 ? "clave" : "claves"}
                            </Typography>
                          </Box>

                          {/* Badges de formatos en el header */}
                          <Box display="flex" gap={1}>
                            {grupo.claves.some(
                              (c) =>
                                c.formatoEncriptacion?.toLowerCase() === "gcm",
                            ) && (
                              <Chip label="GCM" color="primary" size="small" />
                            )}
                            {grupo.claves.some((c) => c.necesitaMigracion) && (
                              <Chip
                                label="Requiere Migración"
                                size="small"
                                style={{
                                  backgroundColor: "#fff3e0",
                                  color: "#e65100",
                                }}
                              />
                            )}
                          </Box>
                        </Box>
                      </AccordionSummary>

                      {/* Contenido del Accordion */}
                      <AccordionDetails className={classes.accordionContent}>
                        <Box width="100%">
                          {grupo.claves.map((clave, index) => {
                            const {
                              usuario,
                              clave: claveEncriptada,
                              institucion,
                              tipoClave,
                              refCliente,
                              formatoEncriptacion,
                              necesitaMigracion,
                              visibleCliente,
                            } = clave;

                            const claveUnica = generarClaveUnica(
                              refCliente,
                              institucion,
                              usuario,
                            );

                            return (
                              <React.Fragment key={claveUnica}>
                                <Box className={classes.claveCard}>
                                  <Grid
                                    container
                                    spacing={2}
                                    alignItems="center"
                                  >
                                    {/* Columna 1: Usuario y Tipo */}
                                    <Grid item xs={12} md={4}>
                                      <Typography
                                        variant="body2"
                                        color="textSecondary"
                                      >
                                        Usuario
                                      </Typography>
                                      <Typography
                                        variant="body1"
                                        style={{ fontWeight: 500 }}
                                      >
                                        {usuario}
                                      </Typography>
                                      <Typography
                                        variant="caption"
                                        color="textSecondary"
                                      >
                                        {tipoClave || "Sin especificar"}
                                      </Typography>
                                      <Box
                                        mt={1}
                                        display="flex"
                                        alignItems="center"
                                        gap={1}
                                        flexWrap="wrap"
                                      >
                                        <FormControlLabel
                                          control={
                                            <Switch
                                              size="small"
                                              color="primary"
                                              checked={!!visibleCliente}
                                              disabled={
                                                updatingVisibilidadId ===
                                                clave.id
                                              }
                                              onChange={() =>
                                                handleToggleVisibilidad(clave)
                                              }
                                            />
                                          }
                                          label={
                                            <Typography variant="caption">
                                              Visible para el cliente
                                            </Typography>
                                          }
                                        />
                                        {updatingVisibilidadId === clave.id ? (
                                          <CircularProgress size={16} />
                                        ) : (
                                          <Chip
                                            size="small"
                                            label={
                                              visibleCliente
                                                ? "Visible"
                                                : "Oculta"
                                            }
                                            color={
                                              visibleCliente
                                                ? "success"
                                                : "default"
                                            }
                                          />
                                        )}
                                      </Box>
                                    </Grid>

                                    {/* Columna 2: Contraseña y Acciones */}
                                    <Grid item xs={12} md={6}>
                                      <Typography
                                        variant="body2"
                                        color="textSecondary"
                                        gutterBottom
                                      >
                                        Contraseña
                                      </Typography>
                                      <Box
                                        display="flex"
                                        alignItems="center"
                                        gap={0.5}
                                      >
                                        {/* Contraseña */}
                                        <Box
                                          flexGrow={1}
                                          display="flex"
                                          alignItems="center"
                                          minHeight={40}
                                        >
                                          {(() => {
                                            const esVisible =
                                              passwordsVisibles[claveUnica];
                                            const passwordDesencriptada =
                                              passwordsDesencriptadas[
                                                claveUnica
                                              ];

                                            if (
                                              esVisible &&
                                              passwordDesencriptada
                                            ) {
                                              return (
                                                <Typography
                                                  variant="body2"
                                                  style={{
                                                    fontFamily: "monospace",
                                                    fontSize: 14,
                                                    lineHeight: 1.5,
                                                  }}
                                                >
                                                  {passwordDesencriptada}
                                                </Typography>
                                              );
                                            }
                                            return (
                                              <Typography
                                                variant="body2"
                                                style={{ lineHeight: 1.5 }}
                                              >
                                                ••••••••••••
                                              </Typography>
                                            );
                                          })()}
                                        </Box>

                                        {/* Botones de acción */}
                                        <Box
                                          display="flex"
                                          alignItems="center"
                                          gap={0}
                                        >
                                          {puedeVerPassword && (
                                            <Tooltip
                                              title={
                                                !puedeVerPassword
                                                  ? "Solo SUPER_ADMIN pueden visualizar contraseñas"
                                                  : passwordsVisibles[
                                                        claveUnica
                                                      ]
                                                    ? "Ocultar contraseña"
                                                    : "Ver contraseña"
                                              }
                                            >
                                              <span>
                                                <IconButton
                                                  onClick={() =>
                                                    handleTogglePassword(
                                                      refCliente,
                                                      institucion,
                                                      usuario,
                                                      claveEncriptada,
                                                    )
                                                  }
                                                  size="small"
                                                  disabled={isDesencriptando}
                                                  style={{ padding: 8 }}
                                                >
                                                  <Icon
                                                    icon={
                                                      passwordsVisibles[
                                                        claveUnica
                                                      ]
                                                        ? eyeFill
                                                        : eyeOffFill
                                                    }
                                                    width={20}
                                                    height={20}
                                                  />
                                                </IconButton>
                                              </span>
                                            </Tooltip>
                                          )}

                                          <Tooltip title="Copiar al portapapeles">
                                            <span>
                                              <IconButton
                                                onClick={() =>
                                                  handleCopyPassword(
                                                    refCliente,
                                                    institucion,
                                                    usuario,
                                                  )
                                                }
                                                size="small"
                                                disabled={isDesencriptando}
                                                style={{ padding: 8 }}
                                              >
                                                <ContentCopyIcon
                                                  fontSize="small"
                                                  style={{
                                                    width: 20,
                                                    height: 20,
                                                  }}
                                                />
                                              </IconButton>
                                            </span>
                                          </Tooltip>

                                          {puedeVerPassword && (
                                            <Tooltip title="Ver historial de accesos">
                                              <IconButton
                                                onClick={() =>
                                                  handleOpenHistorial(
                                                    refCliente,
                                                    institucion,
                                                    usuario,
                                                  )
                                                }
                                                size="small"
                                                style={{ padding: 8 }}
                                              >
                                                <HistoryIcon
                                                  fontSize="small"
                                                  style={{
                                                    width: 20,
                                                    height: 20,
                                                  }}
                                                />
                                              </IconButton>
                                            </Tooltip>
                                          )}
                                        </Box>
                                      </Box>
                                    </Grid>

                                    {/* Columna 3: Formato y Menú de Acciones */}
                                    <Grid item xs={12} md={2}>
                                      <Box
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems="flex-start"
                                      >
                                        {/* Badge de formato */}
                                        <Box>
                                          {renderFormatoBadge(
                                            formatoEncriptacion,
                                            necesitaMigracion,
                                          )}
                                        </Box>

                                        {/* Botón de menú contextual */}
                                        <Tooltip title="Más opciones">
                                          <IconButton
                                            className={classes.menuButton}
                                            onClick={(e) =>
                                              handleOpenMenu(e, clave)
                                            }
                                            size="small"
                                          >
                                            <MoreVertIcon />
                                          </IconButton>
                                        </Tooltip>
                                      </Box>
                                    </Grid>
                                  </Grid>
                                </Box>

                                {/* Divider entre claves (excepto la última) */}
                                {index < grupo.claves.length - 1 && (
                                  <Divider style={{ margin: "8px 0" }} />
                                )}
                              </React.Fragment>
                            );
                          })}
                        </Box>
                      </AccordionDetails>
                    </Accordion>
                  ))
                )}
              </Box>
            </Scrollbar>

            {open && (
              <AgregarClavesPortales
                open={open}
                setOpen={setOpen}
                refCliente={cliente.rut}
              />
            )}

            {openEditar && (
              <EditarClavesPortales
                elementoSeleccionado={elementoSeleccionado}
                open={openEditar}
                setOpen={setOpenEditar}
                refCliente={cliente.rut}
              />
            )}
          </CardContent>
        </Card>
      )}
      {deleteMessage && (
        <MyConfirmationDialog
          open={deleteMessage}
          onSubmit={() => eliminar(elementoSeleccionado)}
          onClose={() => setDeleteMessage(false)}
          title="Eliminación Claves del Cliente"
          content={`¿Estás seguro de eliminar la clave de acceso para "${elementoSeleccionado.institucion}" con usuario: ${elementoSeleccionado.usuario}?`}
        />
      )}
      {/* Modal de historial de auditoría */}
      {modalHistorialOpen && claveSeleccionadaHistorial && (
        <ModalHistorialAuditoriaClaves
          open={modalHistorialOpen}
          onClose={handleCloseHistorial}
          refCliente={claveSeleccionadaHistorial.refCliente}
          institucion={claveSeleccionadaHistorial.institucion}
          usuario={claveSeleccionadaHistorial.usuario}
          refSucursal={refSucursal}
        />
      )}

      {/* Modal de Advertencia de Seguridad */}
      <ModalAdvertenciaCopiaClave
        open={dialogAdvertenciaOpen}
        onClose={() => {
          setDialogAdvertenciaOpen(false);
          setClaveParaCopiar(null);
        }}
        onConfirm={() => {
          // Cerrar modal y marcar que ya vio la advertencia
          setDialogAdvertenciaOpen(false);
          setMostrarAdvertenciaCopia(false);
          sessionStorage.setItem("vio-advertencia-copia-claves", "true");

          // Ejecutar la copia directamente (sin pasar por handleCopyPassword)
          if (claveParaCopiar) {
            ejecutarCopiaClave(
              claveParaCopiar.refCliente,
              claveParaCopiar.institucion,
              claveParaCopiar.usuario,
            );
            setClaveParaCopiar(null);
          }
        }}
      />

      {/* Menú contextual */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        getContentAnchorEl={null}
      >
        {/* Opción Editar (solo si no es SITAX) */}
        {claveSeleccionadaMenu?.institucion !== "SITAX" && (
          <MenuItem onClick={handleEditarDesdeMenu}>
            <ListItemIcon>
              <EditIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Editar Clave" />
          </MenuItem>
        )}

        {/* Separador entre acciones de edición y eliminación */}
        {claveSeleccionadaMenu?.institucion !== "SITAX" && <Divider />}

        {/* Opción Eliminar */}
        <MenuItem onClick={handleEliminarDesdeMenu}>
          <ListItemIcon>
            <DeleteIcon fontSize="small" color="secondary" />
          </ListItemIcon>
          <ListItemText
            primary="Eliminar Clave"
            primaryTypographyProps={{ color: "secondary" }}
          />
        </MenuItem>
      </Menu>
    </div>
  );
}
